import { useSelector } from 'react-redux'
import Cookie from 'js-cookie'

// Hooks
import { useIsAuthenticated } from 'modules/auth/hooks'

// Types
import { ProfileDefaultValues } from 'modules/profile/models'
import { Profile, State } from 'types'

// Utils
import { subscriptionLaunchDate } from '@constants'
import { isBrowser } from '@process'

export const useProfile = (): Profile => {
  const profileId = useSelector<State, number>(state => state.auth.profileId)
  const profile: Profile = useSelector<State, Profile>(state => {
    return state.entities.profiles[String(profileId)]
  })
  return profile || ProfileDefaultValues
}

export const useIsExistingUser = (): boolean => {
  const profile = useProfile()

  return new Date(subscriptionLaunchDate) >= new Date(profile.date_joined)
}

export const useTheme = (): string | undefined => {
  const isAuthenticated = useIsAuthenticated()
  const profile = useProfile()

  const cookieTheme = Cookie.get('theme')
  const hasCookieTheme = typeof cookieTheme === 'string'

  if (hasCookieTheme) {
    return cookieTheme
  }

  if (isAuthenticated) {
    const theme = profile?.theme
    if (['light', 'dark', 'automatic'].includes(theme)) {
      Cookie.set('theme', theme)
      return theme
    } else {
      Cookie.remove('theme')
    }
    if (theme === 'automatic' && isBrowser) {
      const mql = window.matchMedia('(prefers-color-scheme: dark)')
      const hasMediaQueryPreference = typeof mql.matches === 'boolean'
      if (hasMediaQueryPreference) {
        if (mql.matches) {
          return 'dark'
        }
        return 'light'
      }
    }
  }

  return 'light'
}

export const useDarkMode = (): boolean => {
  const theme = useTheme()
  return theme === 'dark'
}
